export default {
  ptBR: {
    produto: 'Produto',
    contrato: 'Contrato',
    vencimentoOriginal: 'Vencimento original',
    valorOriginal: 'Valor original',
    valorAtualizado: 'Valor atualizado',
    valorTotal: 'Valor total',
    economiaTotal: 'Você economiza',
    porcentagemOff: '{desconto}% OFF',
    aceitarOferta: 'Quero essa oferta!',
    valorTotalAcordo: 'Valor total do acordo',
    dataVencimento: 'Data de vencimento',
    quantidadeParcelasComValorParcela: '{quantidadeParcelas}x de {valorParcela}',
    parceladoEm: 'Parcelado em',
    desconto: 'Desconto',
    pagamento: 'Pagamento',
    ofertaDoDia: 'Oferta do dia',
    outrasOfertas: 'Outra oferta | Outras ofertas',
    confirmandoEmail: 'Confirmando o seu e-mail...',
    erroConfirmandoEmail: 'Ocorreu um erro ao tentar confirmar e-mail.',
    autenticandoSignOn: 'Autenticando usuário...',
    erroAutenticaSignOn: 'Não foi possível carregar a página.',
    detalhesNegociacaoPromocional: 'Detalhes da negociação promocional:',
    confiraInformacoesAcordo: 'Confira as informações do seu acordo e clique no botão abaixo para aceitar a proposta.',
    carregando: 'Carregando...',
    confirmandoAcordo: 'Confirmando acordo...',
    beneficiarioBoleto: 'ACERTO GRUPO INTER FIDC NP',
    atencao: 'Atenção!',
    horas: 'Horas',
    minutos: 'Minutos',
    segundos: 'Segundos',

    tiposPagamento: {
      entrada: 'Entrada de',
      aVista: 'À vista',
      parcelado: 'Parcelado em',
      demaisParcelas: 'Demais parcelas',
    },
    formasDePagamento: {
      title: 'Forma de pagamento',
      boleto: 'Boleto',
    },
    icons: {
      pagamento: 'Ícone forma de pagamento',
      calendario: 'Ícone calendário',
      cifrao: 'Ícone cifrão dinheiro',
      tooltips: 'Ícone de interrogação',
    },
    simbolos: {
      multiplicacao: 'x',
      soma: '+',
    },
    buttons: {
      confirmarProposta: 'Confirmar Proposta',
      confirmarAcordo: 'Confirmar acordo',
      voltar: 'Voltar',
      simuleNovamente: 'Simule novamente',
      telaInicial: 'Ir para a tela inicial',
    },
    resumoOferta: {
      detalhesOfertaEscolhida: 'Detalhes da oferta escolhida:',
      confiraDetalhes: 'Confira os detalhes do seu acordo e confirme para finalizar.',
      observacaoPagamentoComEntrada: 'O vencimento das demais parcelas acontecem todo dia { dia } de cada mês',
      parcelasDe: 'de',
      porcentagemOff: '{desconto}% OFF',
      daEntrada: 'da entrada',
      avisoDataVencimentoPrimeiraParcela: 'A data de vencimento da primeira parcela é:',
    },
    simular: 'Simular',
    simuleOutroValor: 'Simule outro valor.',
    ofertaIdealNaoEncontrada: 'Não achou o acordo ideal?',
    modal: {
      ajuda: 'Ótimo! Vamos te ajudar.',
      escolha: 'Escolha o número de parcelas que você quer pagar:',
      numeroParcela: '{valueParcela}X',
      mensagemSimulador: 'Simulando...',
      vejaOferta: 'Veja como ficou a sua oferta:',
      valorEntrada: 'Entrada de R$ {valorEntrada}',
      valorTotal: 'Total: R$ {valorDivida}',
      valorEconomiza: 'Você economiza R$ {valorDesconto}',
      textoSuaOferta:
        'A sua oferta contempla um valor de entrada que vence no dia {dataVencimento}. Para manter o seu acordo, atente-se ao prazo de pagamento. ',
    },
    appNavigation: {
      saudacao: 'Olá, {primeiroNome}!',
      inicio: 'Início',
      meAjuda: 'Me ajuda',
      sair: 'Sair',
    },

    erros: {
      cpfInvalido: 'O CPF não é válido.',
      cnpjInvalido: 'O CNPJ não é válido.',

      dataNascInvalida: 'A data de nascimento não é válida.',
      dataAberturaInvalida: 'A data de abertura da empresa não é válida.',

      emailInvalido: 'Insira um e-mail válido.',
      emailExistente: 'E-mail já cadastrado no sistema.',
      emailAutenticado: 'Este e-mail já foi autenticado.',

      cpfJaCadastrado: 'CPF já cadastrado.',
      cnpjJaCadastrado: 'CNPJ já cadastrado.',

      celularInvalido: 'O telefone celular não é válido.',
      termosNaoAceitos: 'Você precisa aceitar os termos e condições.',
      desconhecido: 'Erro desconhecido.',
    },

    login: {
      acessarPortal: 'A Acerto facilita sua negociação com parceiros credores.',
      acessarPortalInter: 'Portal de Renegociação do Inter',
      preenchaOCampo: 'Acesse o portal e negocie suas dívidas',
      submit: 'Confirmar',
      voltar: 'Voltar',
      cpf: {
        preenchaOCampoParaBoleto: 'Para consultar boletos de uma dívida negociada, informe seu CPF.',
        docLabel: 'Informe seu CPF:',
        dateHeader: 'Agora, informe sua data de nascimento:',
        dateLabel: 'Data de nascimento:',
        outroTipo: 'É pessoa jurídica?',
        mudarTipo: 'Entrar com CNPJ',
      },
      cnpj: {
        preenchaOCampoParaBoleto: 'Para consultar boletos de uma dívida negociada, informe seu CNPJ.',
        docLabel: 'Informe seu CNPJ:',
        dateHeader: 'Agora, informe a data de abertura da empresa:',
        dateLabel: 'Data de abertura da empresa:',
        outroTipo: 'É pessoa física?',
        mudarTipo: 'Entrar com CPF',
      },
      politicaPrivacidade: {
        titulo: 'Atenção: a Política de Privacidade do nosso site foi atualizada.',
        seguranca: ' Essa é uma forma de reforçar o nosso compromisso com a segurança dos seus dados.',
        saibaMais: 'Para saber mais sobre as atualizações, clique aqui: {0}',
        btnAceitar: 'Aceitar e continuar a negociação',
      },
    },

    cadastro: {
      header: 'Continue o seu cadastro',
      voltar: 'Voltar',
      crieSuaConta: 'Crie sua conta com o seu',
      googleBtn: 'E-mail do Google',
      divider: 'ou preencha os dados abaixo',
      submit: 'Confirmar',

      cpfDate: 'Data de nascimento',
      cnpjDate: 'Data de abertura da empresa',
      phoneLabel: 'Telefone celular',
      emailLabel: 'E-mail',
      confirmEmailLabel: 'Confirme o seu e-mail',
    },

    atualizacaoTermos: {
      privacidade: {
        title: 'Atualizamos nossa Política de Privacidade',
        body: '@:atualizacaoTermos.seguranca.body',
        moreInfo: 'Saiba mais sobre nossa Política de Privacidade.',
      },
      uso: {
        title: 'Atualizamos nossos Termos de Uso',
        body: '@:atualizacaoTermos.seguranca.body',
        moreInfo: ' Saiba mais sobre nossos Termos de Uso.',
      },
      seguranca: {
        title: 'Atualizamos nossos Termos de Uso e Política de Privacidade',
        body: 'Essa é uma forma de reforçar o nosso compromisso com a segurança dos seus dados.',
        moreInfo: 'Saiba mais sobre nossos Termos de Uso e Política de Privacidade.',
      },
    },

    listaDividas: {
      cardProgresso: {
        algoDeuErrado: 'Ops! Algo deu errado!',
        tenteNovamente: 'Tente novamente mais tarde.',
        prontoConsumidor: 'Pronto, {primeiroNome}!',
        confiraOpcoes: 'Confira as melhores opções para você negociar:',
        esseProcessoPodeDemorar: 'Esse processo pode demorar até 1 minuto. Espere só mais um pouco!',
        estamosQuaseLa: 'Estamos quase lá... Buscando melhores oportunidades para você.',
        quasePronto: 'Quase pronto! Continue na página para visualizar suas oportunidades.',
        buscandoUltimoParceiro: 'Buscando o último parceiro...',
        consultandoParceiros: 'Consultando {parceirosConsultados} de {quantidadeParceiros} parceiros...',
        consultandoUltimoParceiro: 'Buscando o último parceiro...',
        vocePossuiUmValorEmAberto: 'Olá, {primeiroNome}! Você possui um valor em aberto no seu cartão.',
        cliqueParaNegociar: 'Clique no botão abaixo para negociar seu cartão de crédito.',
        nenhumaDividaTitulo: '{primeiroNome}, nenhuma dívida foi encontrada em nosso sistema,',
        nenhumaDividaTexto: 'mas separamos algumas dicas de especialista para a sua vida financeira.',
        nenhumaDividaTextoPortalInter:
          'No momento, não encontramos nenhuma dívida em nosso sistema. Você ainda pode verificar no {0} ou ligando no número 3003-4070 para capitais e 0800 940 0007 para demais localidades.',
        nenhumaDividaLinkPortalInter: 'APP do Inter',
      },
    },

    cardDivida: {
      aceitarOferta: 'Quero essa oferta',
      outrasOfertas: 'Ver outras ofertas',
      qtdTentativas: 'Você possui {n} tentativa restante. | Você possui {n} tentativas restantes.',

      ofertaDoDia: 'Oferta do dia',
      desconto: '{0}% de desconto',
      valorTotal: 'Valor total: {0}',

      dividaEhCom: 'Sua dívida é com: {0}',
      produto: 'Produto: {0}',
      vencimentoOriginal: 'Vencimento original: {0}',
      venceuEm: 'Venceu em {0}',
      verDetalhes: 'Ver detalhes',

      tooltipDividaCaduca:
        'Após 5 anos, a sua dívida não deixa de existir. Ela poderá ser cobrada até que ocorra a quitação do valor em aberto por meio de uma negociação.',
    },

    cardDividaButtons: {
      negocie: 'Negocie',
      emProcessamento: 'Em processamento',
      verOfertas: 'Ver ofertas',
      acordoQuitado: 'Acordo quitado',
      verBoletos: 'Ver boletos',
      emAnalise: 'Em análise',

      blank: '',
    },

    detalhesDivida: {
      titulo: 'Detalhes da dívida',
      produto: 'Produto: {0}',
      contrato: 'Contrato: {0} | Contratos: {0}',
      vencimentoOriginal: '@:cardDivida.vencimentoOriginal',
      valorOriginal: 'Valor original: {0}',
      proprietarioDebito: 'Proprietário do Débito: {0}',
      parcelasVencidas: 'Parcelas vencidas: {0}',
      parcelasAVencer: 'Parcelas a vencer: {0}',
      placa: 'Placa: {0}',
      modelo: 'Modelo: {0}',
    },

    composicaoDivida: {
      produto: 'Produto: {0}',
      contrato: 'Contrato: {0} | Contratos: {0}',
      vencimentoOriginal: '@:cardDivida.vencimentoOriginal',
      valorOriginal: 'Valor original: {0}',
      proprietarioDebito: 'Proprietário do Débito: {0}',
    },

    boletos: {
      titleProgress: {
        0: 'Aguardando o pagamento',
        '1-24': 'Você está no caminho certo!',
        '25-49': 'Você está indo muito bem!',
        50: 'Eba! Você já pagou metade do valor :)',
        '51-74': 'Você está quase quitando seu valor em aberto!',
        '75-99': 'Falta pouco!',
        100: 'Você quitou seu valor em aberto. Parabéns!',
      },
      textProgress: {
        0: 'Caso o pagamento não seja realizado, seu acordo de negociação será cancelado.',
        '1-24': 'Fique de olho na data de vencimento para não esquecer de pagar suas parcelas.',
        '25-49': 'Continue pagando as suas parcelas para ter o seu nome limpo e mater o seu acordo!',
        50: 'Você está no caminho certo para quitar a sua dívida e ter o nome limpo ;)',
        '51-74': 'Você pagou mais da metade da sua dívida. Continue assim :) ',
        '75-99': 'Você está a um passo de ter o seu nome limpo e conquistar a sua liberdade financeira!',
        100: 'Você conquistou a liberdade financeira de volta. Parabéns por essa conquista :)',
      },
    },

    propostaAceita: {
      carregandoDivida: 'Carregando a dívida...',
      divida: {
        titulo: 'Parabéns! {0}',
        tituloDestaque: 'Você garantiu um ótimo acordo.',
        propostaLabel: 'Seu acordo foi de:',
        aviso: 'Pague a primeira parcela até dia {0} para manter seu acordo ativo.',
        avisoBeneficiarioBoleto:
          'Para limpar o seu nome e evitar que seu acordo seja cancelado, é importante que você pague o seu boleto, cujo beneficiário é {0}, até o dia {1}, ok?',
      },
      preCreli: {
        titulo: 'Pronto! As faturas do seu cartão foram negociadas!',
        tituloDestaque: '',
        propostaLabel: 'Resumo:',
        aviso:
          'Para ficar livre de pendências e evitar que seu acordo seja cancelado, não se' +
          ' esqueça de pagar seu boleto até o dia {0}, ok?',
      },
      desejaVisualizarTermoAcordo: 'Caso queira visualizar o Termo de Acordo, clique ao lado para baixar:',
      baixarTermoAcordo: 'Baixar termo',
      acompanhePagamento: 'Acompanhe os dados das suas parcelas',
      verMais: 'Ver mais',
      verMenos: 'Ver menos',
      acompanhamentoOutrasParcelas: {
        titulo: 'Atenção!',
      },
      credor: 'Riachuelo',
    },

    salvarCalendarioBoleto: {
      escolha: 'Escolha onde você quer salvar:',
      eventDescription: 'Pague agora e mantenha os descontos da sua negociação.',
      modalSalvarEventoTitle: 'Ótimo!',
      salvarEventoEntradaMaisOutrasParcelas:
        'Só falta salvar as datas de vencimento dos seus boletos. Salve a data do pagamento da entrada e, em seguida, a data das demais parcelas.',
      dataPrimeiraParcela: 'Data da primeira parcela',
      dataDemaisParcelas: 'Data das demais parcelas',
      pagamentoDemaisParcelas: 'Todo dia {dia} do mês. A partir de {mes}.',
    },

    cardBoleto: {
      numeroParcela: '{numeroParcela}ª parcela',
      statusParcela: {
        aberta: 'Aberta',
        paga: 'Paga',
        vencida: 'Vencida',
      },
      dataPagamento: 'Data do pagamento',
      statusBoleto: {
        aguardandoPagamento: 'Aguardando pagamento',
        pagamentoRecebido: 'Pagamento recebido',
        parcelaVencida: 'Parcela vencida',
      },
      dataVencimento: 'Vencimento',
      baixarBoleto: 'Baixar boleto',
      copiarLinhaDigitavel: 'Copiar código de barras',
      liberarBoleto: 'Liberar boleto',
      gerandoBoleto: 'Gerando boleto...',
    },

    propostaEmAnalise: {
      suaPropostaEmAnalise: 'Sua proposta está em análise',
      acompanheStatusNegociacao: 'Acompanhe o status da sua negociação:',
      enviada: 'Enviada',
      emAnalise: 'Em análise',
      negociacaoAprovada: 'Negociação aprovada',
      pagamentoPrimeiraParcela: 'Pagamento da 1ª parcela',
      pagamentoDemaisParcelas: 'Pagamento demais parcelas',
      dividaQuitada: 'Dívida quitada',
      resumoPropostaAceita: 'A sua proposta foi de*:',
      detalhePropostaAceita: '*por tempo limitado, os valores podem sofrer pequenas alterações',
      proximosPassos: 'Próximos passos',
      proximosPassosCard: {
        suaPropostaEmAvaliacao: 'Sua proposta está em avaliação',
        dentroDePoucosDias: 'Dentro de poucos dias você receberá um e-mail e SMS informando o status da sua proposta.',
        pagamentoEntradaCodigoBarras: 'Pagamento da entrada via código de barras',
        aposAprovacaoOCodigo:
          'Após a aprovação, o código de barras é enviado via e-mail e SMS para pagamento da entrada',
        naoAtrasePagamento: 'Não atrase o pagamento',
        casoAcontecaAtraso:
          'Caso isso aconteça, os beneficios adquiridos na sua negociação são automaticamente cancelados.',
        nomeLimpoDias: 'Nome limpo em 5 dias úteis',
        aposDataVencimentoNomeLimpo: 'Após a data de vencimento do boleto, o seu nome fica limpo em até 5 dias úteis.',
      },
    },

    cardAvisoParcelaVencida: {
      titulo: 'Atenção!',
      textoDestaque: 'Você possui uma parcela vencida.',
      textoRestante:
        'Após a data de vencimento, os valores do boleto serão atualizados. Verifique as informações antes de efetuar o pagamento.',
      detalhe:
        '*Se você já efetuou o pagamento, não se preocupe, o reconhecimento pode levar até 10 dias para acontecer.',
    },

    deepLink: {
      saudacaoUsuario: 'Olá, {nome}!',
      messagemOferta: {
        ofertaRecebidaMaior: {
          text: '{0} Houve um pequeno ajuste na sua proposta. Confira o novo valor e clique no botão de confirmação caso deseje aceitar o acordo.',
          textStrong: 'Atenção!',
        },
        ofertaRecebidaMenor: {
          text: 'Liberamos um {0} para o seu acordo. Confira o novo valor e clique no botão abaixo para aceitar a proposta.',
          textStrong: 'desconto maior ',
        },
        ofertaRecebidaIgual: {
          text: 'A sua proposta está pronta. Confira as informações e clique no botão abaixo para {0}',
          textStrong: 'aceitar o acordo.',
        },
      },
    },

    cardCancelamentoAcordo: {
      dataFormalizacao: 'Data da formalização {0}',
      dataCancelamento: 'Data do cancelamento: {0}',
      valorAcordo: 'Valor do acordo: {0}',
    },
  },
};
